export default "__VITE_ASSET__BpHYaRVc__"